/**
 * @generated SignedSource<<75ec41adea9dd1f9da94f450be44bcaf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type UserStatus = "accepted" | "applied" | "deleted" | "pending" | "rejected" | "unverified";
import { FragmentRefs } from "relay-runtime";
export type BlogPostList_User$data = {
  readonly blogPosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"BlogPostListItem_BlogPost">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly self: boolean | null | undefined;
  readonly status: UserStatus | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"user_useIsMember">;
  readonly " $fragmentType": "BlogPostList_User";
};
export type BlogPostList_User$key = {
  readonly " $data"?: BlogPostList_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostList_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPostList_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "self",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 10
        }
      ],
      "concreteType": "BlogPostConnection",
      "kind": "LinkedField",
      "name": "blogPosts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BlogPostEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "BlogPost",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "BlogPostListItem_BlogPost"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "blogPosts(first:10)"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "user_useIsMember"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "b88be05dbcfde33b16a3cac733f1eac9";

export default node;
